// extracted by mini-css-extract-plugin
export default {"container":"FeedItem_container__gXI41","first":"FeedItem_first__roJym","last":"FeedItem_last__JQlm+"};